<template>
    <div class="top-tags">
        <div class="tags-body">
            <p><a href="#" @click="this.$router.push('/')">首页</a> > <a href="#" @click="this.$router.push('/Charge')">收费标准</a></p>
        </div>
    </div>
    <div class="charge-body">
        <h3>送评流程</h3>
        <div class="time-line">
            <el-timeline>
                <el-timeline-item
                v-for="(activity, index) in activities"
                :key="index"
                :timestamp="activity.timestamp"
                >
                
                {{ activity.content }}
                </el-timeline-item>
            </el-timeline>
        </div>
        
        <h3>收费标准</h3>
        <div class="standard-body">
            
            <el-table :data="standardData1" style="width: 100%"
            :header-cell-style="{'text-align': 'center'}"
            :cell-style="{'text-align': 'center'}"
            >
                <el-table-column label="古钱币评级收费标准">
                    <el-table-column prop="title" label="估价"/>
                    <el-table-column prop="content" label="收费" />
                </el-table-column>
            </el-table>

        </div>

        <h3>送评单格式</h3>
        <div class="order-body">
            
            <el-table :data="orderData" style="width: 100%"
            :cell-style="{'text-align': 'center'}"
            >
                <el-table-column label="评级送评单格式 ">
                    <el-table-column label="邮寄地址：河南省开封市通许县金达广场政泉评级">
                        <el-table-column label="姓名与电话：xxx 178 3784 4475">
                            <el-table-column prop="no" label="No" />
                            <el-table-column prop="name" label="名称"/>
                        </el-table-column>
                        
                        <el-table-column label="联系地址：">
                            <el-table-column prop="number" label="数量" />
                            <el-table-column prop="year" label="年代" />
                            <el-table-column prop="species" label="品种" />
                        </el-table-column>
                    </el-table-column>    
                </el-table-column>
            </el-table>

        </div>
        <!-- <h3>汇款账号</h3>
        <div class="remittance-body">
            <el-image :src="url" />
        </div> -->

    </div>
</template>

<script>
export default {
    data () {
        return {
            //汇款
            url: require("../assets/img/address/companyaddress.jpg"),
             
            activities: [
                {
                    content: '1.接待处送评',
                },
                {
                    content: '2.填写评级单',
                },
                {
                    content: '3.邮寄钱币与送评单',
                },
                {
                    content: '4.本公司收到包裹并联系送评人核对并告知评级费，专家进行评级后台录入评级结果',
                },
                {
                    content: '5.进入评级',
                },
                {
                    content: '6.封装并寄回',
                },
            ],
            standardData1: [
                {
                    title: '1000元以内',
                    content: '30元',
                },
                {
                    title: '1000元到3000元',
                    content: '40元',
                },
                {
                    title: '3000元到5000元',
                    content: '50元',
                },
                {
                    title: '5000元到10000元',
                    content: '80元',
                },
                {
                    title: '1万元到3万元',
                    content: '150元',
                },
                {
                    title: '3万元到10万元',
                    content: '260元',
                },
            ],
            orderData: [
                {
                    no: '1',
                    name: 'XXXX',
                    number: 'xxxx',
                    year: 'xxxx',
                    species: 'xxxx'
                },
                {
                    no: '1',
                    name: 'XXXX',
                    number: 'xxxx',
                    year: 'xxxx',
                    species: 'xxxx'
                },
                {
                    no: '1',
                    name: 'XXXX',
                    number: 'xxxx',
                    year: 'xxxx',
                    species: 'xxxx'
                },
                {
                    no: '1',
                    name: 'XXXX',
                    number: 'xxxx',
                    year: 'xxxx',
                    species: 'xxxx'
                },
                {
                    no: '1',
                    name: 'XXXX',
                    number: 'xxxx',
                    year: 'xxxx',
                    species: 'xxxx'
                },
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
//-------------------------------小跳转菜单
.top-tags {
    width: 100%;
    height: 40px;
    background: #f3f3f3;
    .tags-body {
        width: 1210px;
        margin: 0 auto;
        border: 1px solid #f3f3f3;
        text-align: left;
        position: relative;
        @media only screen and (max-width: 1210px) {
            width: 100%;
        }
        
        p {
            margin-top: 10px;
            padding-left: 5px;
            border-left: 6px solid #409EFF;
            
            a {
                color: #303133;
                font-size: 14px;
                text-decoration: none;
                &:hover {
                    color: #409EFF;
                }
            }
        }
    }
}
.charge-body {
    width: 1400px;
    margin: 0 auto;
    @media only screen and (max-width: 1400px) {
        width: 100%;
    }
    h3 {
        @media only screen and (max-width: 810px) {
            width: 90%;
            margin: 20px 5%;
        }
        font-size: 24px;
        text-align: left;
        margin: 20px 96px;
        padding: 10px 0;
        border-bottom: 1px solid #DFDFDF;
        position: relative;
        &::after {
            content: "";
            position: absolute;
            left: 48px;
            bottom: -1px;
            width: 100px;
            height: 2px;
            margin-left: -50px;
            background-color: #409EFF;
        }
    }
    .time-line, .standard-body, .order-body, .remittance-body{
        padding-left: 94px;
        text-align: left;
        line-height: 30px;
        @media only screen and (max-width: 1300px) {
            padding: 0 4%;
        }
        @media only screen and (max-width: 735px) {
            padding: 0 1%;
        }
    }
    // .remittance-body {
        
    // }
}
</style>